<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-app id="app">
      <navigation-bar v-if="$store.state.user.logged_in"/>
      <rightHandDrawer/>
      <!--      APP injects here-->
      <router-view/>
      <footerBar v-if="$store.state.user.logged_in"/>

      <component
          :is="$store.state.app.activeDialogComponent"
          v-bind="$store.state.app.activeDialogComponentProps"
      ></component>
    </v-app>
  </div>
</template>

<script>
import navigationBar from '@/components/application-level/navigation-bar';
import rightHandDrawer from '@/components/application-level/right-hand-drawer';
import footerBar from '@/components/application-level/footer-bar';
import '@/assets/css/trade-custom.scss';
import '@/assets/css/trade-crm-custom.scss';
import get_countries from '@/components/application-level/mixins/vFmt';
import {handle_crm_url_params} from '@/components/trade-crm-app/js/crm_url_parameters';
import {
  getLoginReferrerFromReloadUrl,
  toCanonicalReloadUrl,
} from '@/components/application-level/js_functions/referrer-utils';
// import {is_compatible_browser} from "@/components/application-level/js_functions/browser_checks.ks";
export default {
  name: 'App',
  mixins: [get_countries],
  components: {
    navigationBar,
    rightHandDrawer,
    footerBar,
    // load_edit_save_list
  },
  beforeMount() {
    console.log(
        'Process Environment reports this url - ',
        process.env.VUE_APP_BACKEND_URL,
    );
    console.log('Setting internal URL to', process.env.VUE_APP_BACKEND_URL);
    this.$store.commit('setBaseUrl', process.env.VUE_APP_BACKEND_URL);
    // console.log('Store updated, the value of the URL in the store is...');
    console.log('Store base url  - ', this.$store.getters.baseUrl);
    history.pushState(null, null, location.href);
  },
  mounted() {
    console.log('Checking browser compatibility ...');
    // if (is_compatible_browser()===false ) {
    //   localStorage.setItem("browser_compatible", "false")
    // } else {
    localStorage.setItem('browser_compatible', 'true');

    console.log('Opening login page ...');
    //check the query sring in the url
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    console.log(queryString);

    handle_crm_url_params(urlParams);

    let referrer = urlParams.get('referrer');
    // check if there is a reload url
    let reload_url = localStorage.getItem('reload_url');

    // if there is a reload url available and no referrer in query string
    // we use the stored reload_url but ensure it's in canonical format
    if (reload_url !== null && referrer === null) {
      // Extract referrer from stored reload_url (handles legacy formats)
      const storedReferrer = getLoginReferrerFromReloadUrl(reload_url);
      
      // Convert to canonical format
      const canonicalUrl = toCanonicalReloadUrl(storedReferrer);
      
      // Update localStorage with canonical format if it was in legacy format
      if (reload_url !== canonicalUrl) {
        localStorage.setItem('reload_url', canonicalUrl);
      }
      
      // set the base login page
      this.$store.state.app.base_login_page = canonicalUrl;
      // go there
      this.$router.push(canonicalUrl);
    } else {
      // there was a referrer in query string, it will override the reload url
      window.history.replaceState({}, document.title, '/');

      // Build canonical login URL with query param
      const canonicalUrl = toCanonicalReloadUrl(referrer);
      
      this.$store.state.app.base_login_page = canonicalUrl;
      localStorage.setItem('reload_url', canonicalUrl);

      let debug = false;
      if (debug === true) {
        this.$router.push({path: '/login', query: {referrer: 'aexi'}});
      } else {
        this.$router.push(canonicalUrl);
      }
    }
    // }
  },
  data() {
    return {};
  },
  methods: {},
}; // export
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Questrial');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;600;800&display=swap');

#app {
  font-family: 'Open Sans', Helvetica, Arial, Verdana, sans-serif;
}
</style>
